import React from 'react';
import PropTypes from 'prop-types';
import { PlaidLink } from 'react-plaid-link';

import { create } from '../../feathersWrapper';
import { PersonContext } from '../../contexts/PersonContext';

class PlaidLinkAuth extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { loading: true };
  }

  async componentDidMount() {
    const { organizationId } = this.context;
    const token = await create(this, 'plaid-link-tokens', {
      organizationId,
      auth: true,
    });
    this.setState({ token, loading: false });
  }

  componentWillUnmount() {
    document.body.style.removeProperty('overflow');
  }

  onSuccess = async (token, metadata) => {
    const { organizationId } = this.context;
    const { onSuccess } = this.props;
    const itemResponse = await create(this, 'plaid-items', {
      organizationId,
      auth: true,
      plaidPublicToken: token,
      plaidMetadata: metadata,
    });

    await onSuccess(itemResponse.stripeBankAccountToken);

    // for some reason plaid adds overflow hidden on closing - this prevents scrolling
    setTimeout(() => { document.body.style.removeProperty('overflow'); }, 2000);
  };

  // eslint-disable-next-line no-unused-vars
  onExit = async (error, metadata) => {
    const { closeDialog } = this.props;
    closeDialog();
    // for some reason plaid adds overflow hidden on closing - this prevents scrolling
    setTimeout(() => { document.body.style.removeProperty('overflow'); }, 2000);
  };

  render() {
    const { loading, token } = this.state;

    if (loading) {
      return null;
    }

    return (
      <PlaidLink
        token={token}
        onSuccess={this.onSuccess}
        onExit={this.onExit}
        onLoad={() => { document.getElementById('plaidLinkAuth').click(); }}
        style={{ display: 'none' }}
      >
        <span id="plaidLinkAuth">Connect a bank account</span>
      </PlaidLink>
    );
  }
}

PlaidLinkAuth.contextType = PersonContext;

PlaidLinkAuth.defaultProps = {
};

PlaidLinkAuth.propTypes = {
  // classes: PropTypes.objectOf(PropTypes.string).isRequired,
  onSuccess: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
};

export default PlaidLinkAuth;
